// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#assets-modal-component .body[data-v-2b0f0b59]{padding:16px}#assets-modal-component .separator[data-v-2b0f0b59]{background-color:var(--border-1-color)}#assets-modal-component .disabled[data-v-2b0f0b59]>:not(.op1){opacity:.35}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
